function Cancel() {

    return (
        <div className="container">
            <div style={{backgroundColor:'#ab0404', color:'#fff', textAlign:'center', padding:50}}>
                <h2>Cancel Payment...</h2>
                <div>We were unable to process your payment. Please try again, try a different payment method, or contact us if you continue to have issues.</div>
            </div>
        </div>
    );
  }
  
  export default Cancel;